import { render, staticRenderFns } from "./CodesysIcon.vue?vue&type=template&id=5d45d539"
import script from "./CodesysIcon.vue?vue&type=script&lang=js"
export * from "./CodesysIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports